import React from "react"
import { Heading, VStack, Text, Link } from "@chakra-ui/react"

export default function Telephone({ data }) {
  return (
    <VStack align={{ base: "center", lg: "start" }} spacing={6}>
      <Heading as="h3" size="2xl">
        Telephone
      </Heading>
      <Text textAlign={{ base: "center", lg: "start" }}>
        If you would rather speak to someone directly give us a call on:
      </Text>
      <Link
        href={`tel:${data.tel}`}
        fontWeight="medium"
        lineHeight={1}
        size="xl"
      >
        {data.tel}
      </Link>
    </VStack>
  )
}
